import * as msal from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "", // This is the ONLY mandatory field that you need to supply
    authority: "", //  Replace the placeholder with your tenant info
    redirectUri: "/", // You must register this URI on App Registration. Defaults to window.location.href e.g. http://localhost:3000/
    navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO.
    storeAuthStateInCookie: false, // set this to true if you have to support IE
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case msal.LogLevel.Error:
            console.error(message);
            return;
          case msal.LogLevel.Info:
            console.info(message);
            return;
          case msal.LogLevel.Verbose:
            console.debug(message);
            return;
          case msal.LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

export async function getMsalInstance() {
  const msalCredentials = await fetch(`/authentication/msalcredentials`)
    .then(res => res.json());
  const instanceConfig = msalConfig;
  instanceConfig.auth.clientId = msalCredentials.clientId;
  instanceConfig.auth.authority = msalCredentials.authority;

  const msalInstance = new msal.PublicClientApplication(instanceConfig);
  
  return msalInstance;
};
